<template>
  <div class="camera-equ">
    <div class="camera-equ-top">
      <el-button class="btn btn-left btn-all" @click="addCameraClick(1)" :disabled="newPrivilege==1" :class="[newPrivilege==1?'active':'']">新建摄像设备 +</el-button>
      <div style="clear:both;"></div>
    </div>
    <div class="camera-equ-table">
      <el-table
        :header-cell-style="{background:'#f3f3f3',color:'#323232',height:'50px'}"
        :data="yemiandata"
        border
        style="width: 100%">
        <el-table-column
          prop="camera_id"
          label="摄像头编号"
          width="">
        </el-table-column>
        <el-table-column
          prop="station_name"
          label="场站名称"
          width="">
        </el-table-column>
        <el-table-column
          prop="serial_no"
          label="序列号">
          <template slot-scope="scope">{{ scope.row.serial_no | defaultValFilter }}</template>
        </el-table-column>
        <el-table-column
          prop="nvr_serial_no"
          label="NVR盒子序列号"
          width="">
          <template slot-scope="scope">{{ scope.row.nvr_serial_no | defaultValFilter }}</template>
        </el-table-column>
        <el-table-column
          prop="video_link"
          label="视频链接（hls格式）"
          :show-overflow-tooltip="true"
          width="">
          <template slot-scope="scope">{{ scope.row.video_link | defaultValFilter }}</template>
        </el-table-column>
         <!--<el-table-column
          prop="video_link1"
          label="视频链接（hls格式）"
          :show-overflow-tooltip="true"
          width="">
          <template slot-scope="scope">{{ scope.row.video_link1 | defaultValFilter }}</template>
        </el-table-column>-->
        <el-table-column
        width="140"
          prop="created_time"
          label="创建时间">
        </el-table-column>
        <el-table-column
          label="操作"
          width="160">
          <template slot-scope="scope">
              <el-button class="btn edit" @click="editCamera(scope.row,2)" :disabled="editPrivilege==1" :class="[editPrivilege==1?'active':'']">编辑</el-button>
              <el-button class="btn delete" @click="deleteCamera(scope.row)" :disabled="deletePrivilege==1" :class="[deletePrivilege==1?'active':'']">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination">
        <el-pagination
        background
        layout="prev, pager, next"
        @size-change="handleSizeChange" 
        @current-change="currentChange"
        :total="totalNum">
        </el-pagination>
    </div>
    <!-- 新建 -->
    <el-dialog
		:visible.sync="addCameraDialog"
    customClass="camera-dialog"
		width="934px"
    @close="cameraCancelClick"
    :close-on-click-modal="false"
		>
      <p class="title">{{cameraTitle}}</p>
      <div class="line"></div>
      <div class="camera-box">
        <div class="camera-row">
          <div class="camera-l"><span class="star">*</span>场站：</div>
          <div class="camera-r">
            <el-select v-model="cameraProvince" clearable :disabled="dialogNum==2" placeholder="请选择省" @change="cameraProviceChange">
              <el-option
                v-for="item in cameraProvinceList"
                :key="item.province"
                :label="item.province"
                :value="item.province">
              </el-option>
            </el-select>
            <el-select v-model="cameraCity" clearable :disabled="dialogNum==2" placeholder="请选择市" @change="cameraCityChange">
              <el-option
                v-for="item in cameraCityList"
                :key="item.city"
                :label="item.city"
                :value="item.city">
              </el-option>
            </el-select>
            <el-select v-model="cameraStation" clearable :disabled="dialogNum==2" placeholder="请选择场站" @change="cameraStationChange">
              <el-option
                v-for="item in cameraStationList"
                :key="item.station_id"
                :label="item.station_name"
                :value="item.station_id">
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="camera-row">
          <div class="camera-l"><span class="star">*</span>编号：</div>
          <div class="camera-r">
            <el-input v-model="camera_id" clearable placeholder="请输入摄像头编号，唯一"></el-input>
          </div>
        </div>
        <div class="camera-row">
          <div class="camera-l">序列号：</div>
          <div class="camera-r">
            <el-input v-model="serial_no" clearable placeholder="请输入序列号"></el-input>
          </div>
        </div>
        <div class="camera-row">
          <div class="camera-l">NVR序列号：</div>
          <div class="camera-r">
            <el-input v-model="nvr_serial_no" clearable placeholder="请输入NVR序列号"></el-input>
          </div>
        </div>
        <div class="camera-row">
          <div class="camera-l"><span class="star">*</span>视频播放链接(rtmp)：</div>
          <div class="camera-r">
            <el-input v-model="video_link" clearable placeholder="请输入视频播放链接rtmp格式"></el-input>
          </div>
        </div>
        <div class="camera-row">
          <div class="camera-l"><span class="star">*</span>视频播放链接(hls)：</div>
          <div class="camera-r">
            <el-input v-model="video_link1" clearable placeholder="请输入视频播放链接hls格式"></el-input>
          </div>
        </div>
        <div class="camera-button">
          <el-button class="camera-cancel" @click="cameraCancelClick()">取消</el-button>
          <el-button class="camera-confirm" @click="cameraConfirmClick()">确认</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props:["provincesName","cityName","stationId"],
  data () {
    return {
      addCameraDialog:false,
      cameraTitle:"新建摄像设备",
      tableData: [],
      // 页面需要展现的数据
      yemiandata:[],
      // 页面展现条数
      datanum:10,
      // 开始页数
      startnum:0,
      // 结束页数
      endnum:1,
      // 一共多少页
      totalNum:0,
      cameraProvince:"",
      cameraProvinceList:[],
      cameraCity:"",
      cameraCityList:[],
      cameraStation:"",
      cameraStationList:[],
      dialogNum:0,
      camera_id:"",
      serial_no:"",
      nvr_serial_no:"",
      video_link:"",
      video_link1:"",
      cameraId:"",
      newPrivilege:1,//新建
      editPrivilege:1,//编辑
      deletePrivilege:1,//删除
    }
  },
  mounted(){
    this.$nextTick(function() {

      let role = [];
      role = this.$store.state.role;
      for(let i in role){
        if(role[i].view_name == "场站管理"){
          for(let j in role[i].chlid){
            if(role[i].chlid[j].view_name == "设备管理"){
              for(let m in role[i].chlid[j].method){
                if(role[i].chlid[j].method[m].method_name == "新建摄像头"){
                  this.newPrivilege = 0;
                } else if(role[i].chlid[j].method[m].method_name == "编辑摄像头"){
                  this.editPrivilege = 0;
                } else if(role[i].chlid[j].method[m].method_name == "删除摄像头"){
                  this.deletePrivilege = 0;
                }
              }
            }
          }
        }
      }
      
      this.getCameraList(this.provincesName,this.cityName,this.stationId);
    });
  },
  watch:{
    "stationId":function(newVal,oldVal){
      this.totalNum = 0;
      this.startnum = 0;
      this.endnum = 1;
      this.getCameraList(this.provincesName,this.cityName,this.stationId);
    },
  },
  methods:{
    handleSizeChange(data){
      // debugger
    },
    currentChange(data){
      this.endnum = data;
      this.startnum = data-1;
      this.yemiandata=this.tableData.slice(this.startnum*this.datanum,this.endnum*this.datanum);
    },
    getCameraList(provincesName,cityName,stationId){
      if(provincesName==undefined){
          provincesName = "";
      }
      if(cityName==undefined){
          cityName = "";
      }
      if(stationId==undefined){
          stationId = "";
      }

      let params = {
          uid: localStorage.getItem("uid"),
          token: localStorage.getItem("token"),
          action:"getCameraList",
          province:provincesName,
          city:cityName,
          station_id:stationId,
      };
      this.$api({
          method: "post",
          url: "/api.php/DeviceManage/index",
          data: params,
          transformRequest: [
          data => {
              let ret = "";
              for (let it in data) {
              ret += encodeURIComponent(it) + "=" + encodeURIComponent(data[it]) + "&";
              }
              return ret;
          }
          ]
      })
          .then(su => {
              if(su.data.code == 1){
                  this.tableData = su.data.list;
                  this.totalNum = this.tableData.length;
                  if(this.totalNum > 10){
                    this.yemiandata=this.tableData.slice(this.startnum*this.datanum,this.endnum*this.datanum);
                  } else {
                    this.yemiandata=this.tableData;
                  }
                  
              } else if(su.data.code == 300) {
                localStorage.clear(); 
                  this.$router.push('/login');
                  this.$message.warning(su.data.message);
              } else if (su.data.code == 900)  {
              } else {
                  this.$message.warning(su.data.message);
              }
          })
          .catch(err => {
      });
    },
    addCameraClick(num){
      this.addCameraDialog = true;
      this.cameraTitle = "新建摄像设备";
      this.getProvinces();
      this.dialogNum = num;
    },
    getProvinces(){
      let params = {
          uid: localStorage.getItem("uid"),
          token: localStorage.getItem("token"),
      };
      this.$api({
          method: "post",
          url: "/api.php/Currency/get_provinces",
          data: params,
          transformRequest: [
          data => {
              let ret = "";
              for (let it in data) {
              ret += encodeURIComponent(it) + "=" + encodeURIComponent(data[it]) + "&";
              }
              return ret;
          }
          ]
      })
          .then(su => {
              if(su.data.code == 1){
                  this.cameraProvinceList = su.data.list;
              } else if(su.data.code == 300) {
                localStorage.clear(); 
                  this.$router.push('/login');
                  this.$message.warning(su.data.message);
              } else if (su.data.code == 900)  {
              } else {
                  this.$message.warning(su.data.message);
              }
          })
          .catch(err => {
      });
    },
    cameraProviceChange(province){
      this.cameraCity = "";
      this.cameraCityList = [];
      this.cameraStation = "";
      this.cameraStationList = [];
      let params = {
          uid: localStorage.getItem("uid"),
          token: localStorage.getItem("token"),
          province:province,
      };
      this.$api({
          method: "post",
          url: "/api.php/Currency/get_citys",
          data: params,
          transformRequest: [
          data => {
              let ret = "";
              for (let it in data) {
              ret += encodeURIComponent(it) + "=" + encodeURIComponent(data[it]) + "&";
              }
              return ret;
          }
          ]
      })
          .then(su => {
              if(su.data.code == 1){
                  this.cameraCityList = su.data.list;
              } else if(su.data.code == 300) {
                localStorage.clear(); 
                  this.$router.push('/login');
                  this.$message.warning(su.data.message);
              } else if (su.data.code == 900)  {
              } else {
                  this.$message.warning(su.data.message);
              }
          })
          .catch(err => {
      });
    },
    cameraCityChange(city){
      this.cameraStation = "";
      this.cameraStationList = [];
      let params = {
          uid: localStorage.getItem("uid"),
          token: localStorage.getItem("token"),
          city:city,
      };
      this.$api({
          method: "post",
          url: "/api.php/Currency/get_stations",
          data: params,
          transformRequest: [
          data => {
              let ret = "";
              for (let it in data) {
              ret += encodeURIComponent(it) + "=" + encodeURIComponent(data[it]) + "&";
              }
              return ret;
          }
          ]
      })
          .then(su => {
              if(su.data.code == 1){
                  this.cameraStationList = su.data.list;
              } else if(su.data.code == 300) {
                localStorage.clear(); 
                  this.$router.push('/login');
                  this.$message.warning(su.data.message);
              } else if (su.data.code == 900)  {
              } else {
                  this.$message.warning(su.data.message);
              }
          })
          .catch(err => {
      });
    },
    cameraStationChange(id){
      this.station_id = id;
    },
    cameraCancelClick(){
      this.addCameraDialog = false;
      this.cameraProvince = "";
      this.cameraCity = "";
      this.cameraCityList = [];
      this.cameraStation = "";
      this.cameraStationList = [];
      this.dialogNum = 0;
      this.camera_id = "";
      this.serial_no = "";
      this.nvr_serial_no = "";
      this.video_link = "";
      this.video_link1=""
    },
    cameraConfirm(){
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        action:"addCamera",
        station_id:this.cameraStation,
        camera_id:this.camera_id,
        serial_no:this.serial_no,
        nvr_serial_no:this.nvr_serial_no,
        video_link:this.video_link,
        video_link1:this.video_link1
      };
      this.$api({
          method: "post",
          url: "/api.php/DeviceManage/index",
          data: params,
          transformRequest: [
          data => {
              let ret = "";
              for (let it in data) {
              ret += encodeURIComponent(it) + "=" + encodeURIComponent(data[it]) + "&";
              }
              return ret;
          }
          ]
      })
          .then(su => {
              if(su.data.code == 1){
                  this.$message.success(su.data.message);
                  this.addCameraDialog = false;
                  this.totalNum = 0;
                  this.startnum = 0;
                  this.endnum = 1;
                  this.getCameraList();
                  this.$emit('listenToChildEvent', '空');
                  this.cameraProvince = "";
                  this.cameraCity = "";
                  this.cameraCityList = [];
                  this.cameraStation = "";
                  this.cameraStationList = [];
                  this.dialogNum = 0;
                  this.camera_id = "";
                  this.serial_no = "";
                  this.nvr_serial_no = "";
                  this.video_link = "";
              } else if(su.data.code == 300) {
                localStorage.clear(); 
                  this.$router.push('/login');
                  this.$message.warning(su.data.message);
              } else if (su.data.code == 900)  {
              } else {
                  this.$message.warning(su.data.message);
              }
          })
          .catch(err => {
      });
    },
    editCamera(row,num){
      this.dialogNum = num;
      this.cameraId = row.id;

      this.cameraProvince = row.province;
      this.cameraCity = row.city;
      this.cameraStation = row.station_name;
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        action:"getCameraDetail",
        id:this.cameraId,
      };
      this.$api({
          method: "post",
          url: "/api.php/DeviceManage/index",
          data: params,
          transformRequest: [
          data => {
              let ret = "";
              for (let it in data) {
              ret += encodeURIComponent(it) + "=" + encodeURIComponent(data[it]) + "&";
              }
              return ret;
          }
          ]
      })
          .then(su => {
              if(su.data.code == 1){
                  this.addCameraDialog = true;
                  this.cameraTitle = "编辑摄像设备";
                  this.camera_id = su.data.list.camera_id;
                  this.serial_no = su.data.list.serial_no;
                  this.nvr_serial_no = su.data.list.nvr_serial_no;
                  this.video_link = su.data.list.video_link;
                  this.video_link1 = su.data.list.video_link1;
              } else if(su.data.code == 300) {
                localStorage.clear(); 
                  this.$router.push('/login');
                  this.$message.warning(su.data.message);
              } else if (su.data.code == 900)  {
              } else {
                  this.$message.warning(su.data.message);
              }
          })
          .catch(err => {
      });
    },
    cameraEditConfirm(){
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        action:"editCamera",
        id:this.cameraId,
        station_id:this.cameraStation,
        camera_id:this.camera_id,
        serial_no:this.serial_no,
        nvr_serial_no:this.nvr_serial_no,
        video_link:this.video_link,
        video_link1:this.video_link1
      };
      this.$api({
          method: "post",
          url: "/api.php/DeviceManage/index",
          data: params,
          transformRequest: [
          data => {
              let ret = "";
              for (let it in data) {
              ret += encodeURIComponent(it) + "=" + encodeURIComponent(data[it]) + "&";
              }
              return ret;
          }
          ]
      })
          .then(su => {
              if(su.data.code == 1){
                  this.$message.success(su.data.message);
                  this.addCameraDialog = false;
                  this.getCameraList(this.provincesName,this.cityName,this.stationId);
                  this.cameraProvince = "";
                  this.cameraCity = "";
                  this.cameraCityList = [];
                  this.cameraStation = "";
                  this.cameraStationList = [];
                  this.dialogNum = 0;
                  this.camera_id = "";
                  this.serial_no = "";
                  this.nvr_serial_no = "";
                  this.video_link = "";
                   this.video_link1 = "";
              } else if(su.data.code == 300) {
                localStorage.clear(); 
                  this.$router.push('/login');
                  this.$message.warning(su.data.message);
              } else if (su.data.code == 900)  {
              } else {
                  this.$message.warning(su.data.message);
              }
          })
          .catch(err => {
      });
    },
    cameraConfirmClick(){
      if(this.dialogNum == 1){
        this.cameraConfirm();
      } else if(this.dialogNum == 2){
        this.cameraEditConfirm();
      }
    },
    deleteCamera(row){
      let params = {
          uid: localStorage.getItem("uid"),
          token: localStorage.getItem("token"),
          action:"deleteCamera",
          id:row.id,
      };
      this.$confirm("确定删除", "删除", {
        cancelButtonText: "取消",
        confirmButtonText: "确定",
        type: ""
      })
        .then(() => {
          this.$api({
            method: "post",
            url: "/api.php/DeviceManage/index",
            data: params,
            transformRequest: [
              data => {
                let ret = "";
                for (let it in data) {
                  ret +=
                    encodeURIComponent(it) +
                    "=" +
                    encodeURIComponent(data[it]) +
                    "&";
                }
                return ret;
              }
            ]
          })
            .then(su => {
              if (su.data.code == 1) {
                this.$message.success(su.data.message);
                this.getCameraList(this.provincesName,this.cityName,this.stationId);
              } else if (su.data.code == 300)  {
                localStorage.clear(); 
                this.$router.push("/login");
                this.$message.error(su.data.message);
              } else if (su.data.code == 900)  {
              } else  {
                this.$message.error(su.data.message);
              }
            })
            .catch(err => {});
        })
        .catch(() => {});
    },
  },
}
</script>

<style scoped lang="scss">
.camera-equ {
  .camera-equ-top {
    .btn {
      border:none;
      color:#ffffff;
    }
    .btn-left {
      float: left;
    }
    .btn-all {
      margin-left: 1%;
      background-color: #0177BD;
    }
    .btn-all.active {
      background-color: #a5a5a5;
    }
  }
  .camera-equ-table {
    margin-top: 24px;
    width: 98%;
    margin-left: 1%;
    .btn {
      width: 54px;
      height: 26px;
      color:#ffffff;
      border:none;
      padding:0;
      text-align: center;
      font-size: 12px;
    }
    .edit {
      background-color: #0171BB;
    }
    .edit.active {
      background-color: #a5a5a5;
    }
    .delete {
      background-color: #00B270;
    }
    .delete.active {
      background-color: #a5a5a5;
    }
    .rate {
      background-color: #F15500;
    }
    .disabled {
      background-color: #01A2B4;
    }
    .el-button+.el-button {
      margin-left: 5px;
    }
  }
  .pagination {
    display: flex;
    justify-content: flex-end;
    margin-top: 20px;
    margin-right: 18px;
  }
  .camera-dialog {
    position: relative;
    overflow-x: hidden;
    .title {
      font-size: 18px;
      position: absolute;
      left: 16px;
      top:16px;
      color: #0171BD;
    }
    .line {
      width: calc(100% + 40px);
      margin-left: -20px;
      margin-right: -20px;
      height: 1px;
      margin-top: 14px;
      background-color: #EAEAEA;
      margin-bottom: 30px;
    }
    .camera-box {
      .camera-row {
        width: 90%;
        margin-bottom: 16px;
        .camera-l {
          width: 20%;
          display: inline-block;
          text-align: right;
          .star {
            color: #EE0000;
            margin-right: 4px;
          }
        }
        .camera-r {
          width: 75%;
          display: inline-block;
          .el-select {
            width: 32.5%;
          }
          .el-input {
            width: 99%;
          }
        }
      }
    }
    .camera-button {
      margin-top: 40px;
      .camera-cancel {
        width: 30%;
        background-color: #0071BD;
        color:#ffffff;
        border:none;
        height: 50px;
      }
      .camera-confirm {
        width: 30%;
        background-color: #02B36F;
        color:#ffffff;
        border:none;
        height: 50px;
      }
    }
  }
}
</style>
<style lang="scss">
.camera-equ .el-table--enable-row-hover .el-table__body tr:hover>td .edit {
  background-color: #409EFF;
}
</style>


// WEBPACK FOOTER //
// src/components/stationManagement/cameraEquipment.vue